<template>
  <NuxtLayout>
    <NuxtLoadingIndicator color="#FF174D" :throttle="0"/>
    <NuxtPage />
  </NuxtLayout>
</template>
